import { render } from "./uiIcon.vue?vue&type=template&id=9e66f186"
import script from "./uiIcon.vue?vue&type=script&lang=js"
export * from "./uiIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__